// Vendor imports
const _ = require('lodash')
// Client V1 imports
const { send: ajax } = require('client/lib/request')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')

// Action types

const SHARED_CONVERSATION_FAILED = 'NOTIFICATIONS_SHARED_CONVERSATION_FAILED'
const SHARED_CONVERSATION_LOADED = 'NOTIFICATIONS_SHARED_CONVERSATION_LOADED'
const SHARED_CONVERSATION_LOADING = 'NOTIFICATIONS_SHARED_CONVERSATION_LOADING'
const ADD_COMMENT_FAILED = 'NOTIFICATIONS_ADD_COMMENT_FAILED'
const ADD_COMMENT_LOADED = 'NOTIFICATIONS_ADD_COMMENT_LOADED'
const ADD_COMMENT_LOADING = 'NOTIFICATIONS_ADD_COMMENT_LOADING'
const MARK_COMMENT_READ = 'NOTIFICATIONS_MARK_COMMENT_READ'

// Action dispatchers

function markCommentRead() {
  return async function (dispatch, getState) {
    const participantId = getState().sharedConversation.recipient.id
    await ajax({
      url: `/api/v0.1/share/participant/${participantId}/read`,
      method: 'post'
    })
    dispatch({ type: MARK_COMMENT_READ })
  }
}

function addComment({ commentText }) {
  return async function (dispatch, getState) {
    if (!commentText.length) {
      return dispatch(confirmModalActions.alert({
        heading: 'Comment text required.',
        subheading: 'You must enter some text to post a comment.'
      }))
    }
    const participantId = getState().sharedConversation.recipient.id
    dispatch({
      type: ADD_COMMENT_LOADING
    })
    try {
      const { comment } = await ajax({
        url: `/api/v0.1/share/participant/${participantId}/comment`,
        method: 'post',
        data: {
          text: commentText
        }
      })
      const messages = [
        { ...comment, type: 'text' }
      ]
      dispatch({
        type: ADD_COMMENT_LOADED,
        payload: { messages, participantId }
      })
    } catch (err) {
      dispatch({
        type: ADD_COMMENT_FAILED
      })
      dispatch(confirmModalActions.alert({
        heading: 'Something went wrong.',
        subheading: 'Sorry, we could not add your comment at this time.'
      }))
      throw err
    }
  }
}

function loadConversation(participant) {
  return async function (dispatch) {
    dispatch({
      type: SHARED_CONVERSATION_LOADING,
      payload: { recipient: participant }
    })
    try {
      const { shares } = await ajax({
        url: `/api/v0.1/share/participant/${participant.id}`,
        method: 'get'
      })
      const messages = convertSharesToMessages(shares)
      dispatch({
        type: SHARED_CONVERSATION_LOADED,
        payload: { messages }
      })
      await dispatch(markCommentRead())
    } catch (err) {
      dispatch({
        type: SHARED_CONVERSATION_FAILED
      })
      throw err
    }
  }
}

// Exports

module.exports = {
  // Action types
  SHARED_CONVERSATION_FAILED,
  SHARED_CONVERSATION_LOADED,
  SHARED_CONVERSATION_LOADING,
  ADD_COMMENT_FAILED,
  ADD_COMMENT_LOADED,
  ADD_COMMENT_LOADING,
  MARK_COMMENT_READ,
  // Action dispatchers
  addComment,
  loadConversation
}

// Helpers

function convertSharesToMessages(shares) {
  const messages = _.flatMap(shares, share =>
    _.map(share.comments, comment => ({
      ...comment,
      type: 'text'
    }))
  )
  messages.push(...shares.map(share => ({
    id: share.id,
    type: 'share',
    url: share.url,
    text: share.caption,
    'user_id': share['user_id'],
    status: share.status,
    'created_at': share['created_at']
  })))
  return messages
}
